import { Typography, TypographyProps } from "@mui/material";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

type ActiveOrganizationLabelProps = {
    sx?: TypographyProps["sx"];
};

export const ActiveOrganizationLabel = ({ sx }: ActiveOrganizationLabelProps) => {
    const { selectedCompany } = useFoodpilotContext();

    if (!selectedCompany?.name) {
        return null;
    }

    return (
        <Typography
            sx={{
                fontFamily: "Montserrat",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "180%",
                letterSpacing: 0,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                minWidth: 0,
                ...sx,
            }}
        >
            {selectedCompany.name}
        </Typography>
    );
};
